export const isJson = (jsonString) => {
	try {
		JSON.parse(jsonString)
		return true
	} catch (error) {
		return false
	}
}

// notes : backward compatible of AWSJSON field
export const convertJson = (field) => {
	try {
		return typeof field === 'string' ? JSON.parse(field) : field
	} catch (error) {
		return {}
	}
}

export const parseBatchLots = (lots) => {
	if (typeof lots === 'string') return JSON.parse(lots)
	return lots
}